import { adminApi } from "./adminClient";

export const fetchAdminListings = async (params = {}) => {
  const r = await adminApi.get("/admin/listings", { params });
  return r.data;
};

export const fetchAdminListing = async (idOrSlug) => {
  const r = await adminApi.get(`/admin/listings/${idOrSlug}`);
  return r.data;
};

export const createAdminListing = async (payload) => {
  const r = await adminApi.post("/admin/listings", payload);
  return r.data;
};

export const updateAdminListing = async (idOrSlug, payload, { rename_slug } = {}) => {
  const r = await adminApi.put(`/admin/listings/${idOrSlug}`, payload, {
    params: rename_slug ? { rename_slug: true } : {},
  });
  return r.data;
};

export const deleteAdminListing = async (idOrSlug) => {
  const r = await adminApi.delete(`/admin/listings/${idOrSlug}`);
  return r.data;
};

export const uploadAdminListingPhoto = async (idOrSlug, file) => {
  const form = new FormData();
  form.append("file", file);
  const r = await adminApi.post(`/admin/listings/${idOrSlug}/photo`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return r.data;
};

// Herexporteer de single-source-of-truth uit listings.js zodat er maar één plek
// is met de geldige categorie-slugs. Zo blijft de submission-form nooit uit de
// pas lopen met de bedrijvengids/backend.
export { CATEGORY_OPTIONS } from "./listings";
